




document.addEventListener("DOMContentLoaded", function () {
  const hamburger = document.querySelector(".new-hambrured-on-desktop");
  const colMenu = document.querySelector(".col-menu");

  hamburger.addEventListener("click", function () {
    // Toggle 'active' class on hamburger
    this.classList.toggle("active");

    // Toggle 'active' class on col-menu
    colMenu.classList.toggle("active");
  });




  document.querySelectorAll('a[target="_blank"]').forEach(function(anchor) {
      anchor.removeAttribute('target');
    });


document.querySelectorAll('.filter-men-ps span').forEach(function(element) {
    element.innerHTML = element.innerHTML.replace('products', '');
  element.innerHTML = element.innerHTML.replace('product', '');
});

document.querySelectorAll('.filter-men-ps span').forEach(function(element) {
    element.textContent = element.textContent.replace(/\s+\)/g, ')');
});



  
  
});



